import React, { useEffect, useState } from 'react';
import { Form, Row, Col, Modal } from 'antd';
import { LayoutWithoutAuth, Input, Button, Typography } from 'components';
import { useHistory } from 'react-router-dom';
import './forgot-password.less';
import { customMessages, customValidators } from 'utils';
import { sendForgetOtp } from 'services/login.service';

const { Title } = Typography;

const ForgotPasswordPage = () => {
  let history = useHistory();
  const [form] = Form.useForm();
  const [valid, setValid] = useState(false);

  const onLoginFormSubmit = (values) => {
    
    sendForgetOtp({msisdn:values.msisdn})
    .then((result) => {
      history.push(`/ForgotPasswordApplyCodePage/${values.msisdn}`);
    })
    .catch((response) => {
      Modal.error({
        title: 'Hata',
        content: customMessages.getMessage(response.responseCode),
      });
    });
  };

  const onValuesChange = () => {
    setTimeout(() => {
      let inputs = form.getFieldsError();

      for (var i = 0; i < inputs.length; i++) {
        let formItemName = inputs[i]['name'][0];
        if (checkError(formItemName)) {
          setValid(true);
        } else {
          setValid(false);
          break;
        }
      }
    }, 10);
  };

  const checkError = (fieldName) => {
    if (
      form.isFieldTouched(fieldName) &&
      form.getFieldError(fieldName).length === 0
    ) {
      return true;
    }
  };

  /*const [formValues, setFormValues] = useState(null);
  useEffect(() => {
    return () => {};
  }, [formValues]);*/

  return (
    <LayoutWithoutAuth className="forgot-password">
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center" className="forgot-password-box">
            <Col span={24} className="flex-center-center">
              <h1 className="section__title">Şifremi Unuttum</h1>
            </Col>
            <Col
              span={24}
              className="flex-center-center margin-bottom-spacing-s"
            >
              <p className="info-text--big">
                Sistemimize kayıtlı bulunan telefon numaranızı girerek şifrenizi
                sıfırlayabilirsiniz.
              </p>
            </Col>
            <Form
              form={form}
              style={{ width: '100%' }}
              name="forgotPassword"
              onValuesChange={onValuesChange}
              onFinish={(values) => {
                onLoginFormSubmit(values);
              }}
            >
              <Form.Item
                name="msisdn"
                rules={[
                  {
                    len: 10,
                    validator: customValidators.isMsisdn,
                    required:true,
                    type: "number",
                  },
                ]}
                getValueFromEvent={(e) => {
                  const convertedValue = Number(e.target.value);
                  if (isNaN(convertedValue)) {
                    return "";
                  } else {
                    return convertedValue;
                  }
                }}
              >
                <Input maxLength="10" 
                
                  autoComplete="off"  
                  label="GSM Numaranız"
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item>
                <Form.Item>
                  <Row justify="center" gutter={30}>
                    <Col span={12}>
                      <Button
                        type="ghost"
                        onClick={() => history.push('/Login')}
                      >
                        Geri
                      </Button>
                    </Col>
                    <Col span={12}>
                      <Button
                        type="primary"
                        htmlType="submit"
                        shape="round"
                        disabled={!valid}
                      >
                        Doğrula
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form.Item>
            </Form>
          </Row>
        </Col>
      </Row>
      <Row justify="center">
        <Col xs={24} s={24} md={16} lg={12} xl={10} xxl={10}>
          <Row justify="center">
            <Title level={3}>Üyeliğiniz Yok mu?</Title>
          </Row>
          <Row justify="center" className="margin-bottom-spacing-xxl-4">
            <Button
              type="ghost"
              style={{ width: 180 }}
              onClick={() => history.push('/SignupPage')}
            >
              Üye Ol
            </Button>
          </Row>
        </Col>
      </Row>
    </LayoutWithoutAuth>
  );
};
export default ForgotPasswordPage;
